import React from "react";
import withIntl from "../../utils/withIntl";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import TextFieldForms from "./TextFieldForms";
import SelectForms from "./SelectForms";

function GenericForm(props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit();
      }}
    >
      {props.formData.map((setting) => {
        switch (setting.field) {
          case "text":
            return (
              <TextFieldForms
                label={props.intl.formatMessage({ id: setting.label })}
                value={setting.value}
                type={setting.type}
                onChange={(event) => props.onChangeFields(event.target.value, setting)}
              />
            );
          case "select":
            return <SelectForms label={setting.label} value={setting.value} type={setting.type} />;

          default:
          // code block
        }
      })}
      {props.onSubmit && (
        <div style={{ height: 50 }}>
          <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
          <Button type="submit" style={{ margin: 5, float: "right" }}>
            {props.intl.formatMessage({ id: "save_settings" })}
          </Button>
        </div>
      )}
    </form>
  );
}

export default withIntl(GenericForm);
